module.exports = __webpack_public_path__ + "img/J12687.71f439a1.png";